import * as React from 'react';

import { allCurrencies, cn, Select } from '@rematter/ui-web';

import { EntitySelectProps } from '~/shared/components/select-fields/types';

type SelectCurrencyProps = EntitySelectProps & {
  showAllCurrenciesOption?: boolean;
  format?: 'short-only' | 'long-only' | 'full';
};

export const SelectCurrency = ({
  showAllCurrenciesOption,
  format = 'full',
  ...props
}: SelectCurrencyProps) => {
  const options = React.useMemo(
    () => [
      ...(showAllCurrenciesOption
        ? [{ key: 'all', label: 'All Currencies' }]
        : []),
      ...allCurrencies.map((it) => ({
        key: it.code,
        label: {
          'short-only': it.code,
          'long-only': it.name,
          full: `${it.code}・${it.name}`,
        }[format],
      })),
    ],
    [showAllCurrenciesOption, format],
  );

  return (
    <Select
      {...props}
      className={cn('@SelectCurrency', props.className)}
      options={options}
      onChange={(v) => props.onChange?.(v, v)}
    />
  );
};
